const iplocal = '192.168.18.4'
//const iplocal = '192.168.18.21'
const isPro = !(window.location.host.includes(iplocal) || window.location.host.includes('localhost'));
const Config = {
    apiPhp: isPro?'https://back.dumpster845.com/apiproducto/':`http://${iplocal}/dumpster/index.php/apiproducto/`,
    urlImg: isPro?'https://back.dumpster845.com/assets/uploads/':`http://${iplocal}/dumpster/assets/uploads/`,
    adminUrl: isPro?'https://admin.dumpster845.com/':`http://localhost:5174/`,
    apiAdminPhp: isPro?'https://back.dumpster845.com/apirest/':`http://${iplocal}/dumpster/index.php/apirest/`,
}

export default Config;